import { useQuery } from 'react-query';
import { fetchMainSimulations } from '@/api/main';

export function useMainSimulations() {
  return useQuery('simulations', () => fetchMainSimulations(), {
    keepPreviousData: true,
    retry: false,
  });
}
